import { deleteRequest, get, post, postfd, publicPost, put } from "../helpers/apihelpers";

export const CreateActivityService=async(data)=>{
    try {
        const result = await post(`api/activity/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateActivityService=async(id,data)=>{
    try {
        const result = await put(`api/activity/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteActivityService=async(id)=>{
    try {
        const result = await deleteRequest(`api/activity/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetActivityService=async(type,id)=>{
    try {
        const result = await get(`api/activity/get?type=${type}&id=${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}